import React from 'react'
import "./header.css"

import {  Link } from "react-router-dom";


import clpLogo from "../../../assets/clp-logo.png";

const Header = () => {

  const rsvp = () => {

    window.open('https://mcdtdcubx05.typeform.com/to/icUO5tQR','_blank')
    
  }
  return (
    <div className='headerContainer'>

            <img src={clpLogo} className="navbarClpLogo"/>

            <div className="navLinkContainer">
               <Link to={'/aboutClp'}><div className='aboutClassplus'>About Classplus</div></Link>
               <Link to={'/aboutAnant'}><div className='aboutAnant'>About Anant Ladha</div></Link>
               <Link to={'/contactUs'}><div className='contactUs'>Contact us</div></Link>
                <button className='rsvp'  onClick={()=>rsvp()} >RSVP</button>

            </div>
    </div>
  )
}

export default Header